import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import DefaultGuild from '../../../assets/icons/all-guild.webp';
import * as log from '../../../utils/log';
import { activateUser, banUser, checkname, createGuild, deleteGuild, deleteRequestGuild, deleteUserFromGuildAction, editGuild, getAllGuilds, getMembers, getMyGuild, getOneGuild, joinGuild, leaveGuild, makeAdmin, makeNewOwner, requestGuild, revokeAdmin } from './guildRequest';
import { GuildActionsName } from './guildType';
export const initialState = {
    pending: [],
    needUpdateGuild: false,
    members: null,
    allGuilds: null,
    error: null,
    guildInfo: null,
    isDataSent: [],
    previewPhoto: DefaultGuild,
    errorOnName: null,
    errorLeaveGuild: null,
    myGuildId: null
};
export const filterOutAction = (arrayOfKeys, type) => {
    return arrayOfKeys.filter((name) => name !== type);
};
export const slice = createSlice({
    name: 'guilds',
    initialState,
    reducers: {
        clearData: (state, action) => {
            state.isDataSent = state.isDataSent.filter((name) => name !== action.payload);
            state.pending = state.pending.filter((name) => name !== action.payload);
        },
        setNeedUpdateGuild: (state) => {
            state.needUpdateGuild = true;
        },
        switchPhotoAction: (state, action) => {
            state.previewPhoto = action.payload;
        },
        resetErrors: (state) => {
            state.error = null;
            state.errorOnName = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getMyGuild.fulfilled, (state, action) => {
            state.needUpdateGuild = false;
            state.pending = filterOutAction(state.pending, GuildActionsName.GET_MY_GUILD);
            if (action.payload && action.payload.status === 200) {
                state.guildInfo = action.payload.data;
                state.myGuildId = action.payload.data.id;
            }
            else {
                state.guildInfo = null;
            }
        });
        builder.addCase(getMyGuild.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.GET_MY_GUILD);
        });
        builder.addCase(getMyGuild.pending, (state) => {
            state.needUpdateGuild = false;
            state.guildInfo = null;
            state.myGuildId = null;
            state.pending.push(GuildActionsName.GET_MY_GUILD);
        });
        builder.addCase(getMembers.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.GET_MEMBERS);
            if (action.payload.status === 200) {
                state.members = action.payload.data;
            }
            else {
                state.members = null;
            }
        });
        builder.addCase(getMembers.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.GET_MEMBERS);
        });
        builder.addCase(getMembers.pending, (state) => {
            state.pending.push(GuildActionsName.GET_MEMBERS);
        });
        builder.addCase(makeAdmin.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                state.members = action.payload.data;
                state.isDataSent.push(GuildActionsName.MAKE_ADMIN);
                toast.success('Admin has been added!');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.MAKE_ADMIN);
            }
        });
        builder.addCase(makeAdmin.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.MAKE_ADMIN);
            state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.MAKE_ADMIN);
        });
        builder.addCase(makeAdmin.pending, (state) => {
            state.pending.push(GuildActionsName.MAKE_ADMIN);
        });
        builder.addCase(banUser.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.BAN_USER);
            if (action.payload.status === 200) {
                state.isDataSent.push(GuildActionsName.BAN_USER);
                state.members = action.payload.data;
                toast.success('User has been banned!');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.BAN_USER);
            }
        });
        builder.addCase(banUser.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.BAN_USER);
            state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.BAN_USER);
        });
        builder.addCase(banUser.pending, (state) => {
            state.pending.push(GuildActionsName.BAN_USER);
        });
        builder.addCase(activateUser.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.ACTIVATE_USER);
            if (action.payload.status === 200) {
                state.isDataSent.push(GuildActionsName.ACTIVATE_USER);
                state.members = action.payload.data;
                toast.success('User has been activated!');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.ACTIVATE_USER);
            }
        });
        builder.addCase(activateUser.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.ACTIVATE_USER);
            state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.ACTIVATE_USER);
        });
        builder.addCase(activateUser.pending, (state, action) => {
            state.pending.push(GuildActionsName.ACTIVATE_USER);
        });
        builder.addCase(makeNewOwner.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.MAKE_OWNER);
            if (action.payload.status === 200) {
                state.isDataSent.push(GuildActionsName.MAKE_OWNER);
                state.members = action.payload.data;
                state.myGuildId = undefined;
                toast.success('New owner added');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.MAKE_OWNER);
            }
            if (action.payload.status === 400) {
                state.errorLeaveGuild = action.payload.data.details;
            }
        });
        builder.addCase(makeNewOwner.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.MAKE_OWNER);
            state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.MAKE_OWNER);
        });
        builder.addCase(makeNewOwner.pending, (state) => {
            state.pending.push(GuildActionsName.MAKE_OWNER);
            state.error = null;
        });
        builder.addCase(revokeAdmin.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.REVOKE_ADMIN);
            if (action.payload.status === 200) {
                state.members = action.payload.data;
                state.isDataSent.push(GuildActionsName.REVOKE_ADMIN);
                toast.success('Admin has been revoked!');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.REVOKE_ADMIN);
                toast.error('Guild required at least one Admin');
            }
        });
        builder.addCase(revokeAdmin.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.REVOKE_ADMIN);
            state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.REVOKE_ADMIN);
        });
        builder.addCase(revokeAdmin.pending, (state) => {
            state.pending.push(GuildActionsName.REVOKE_ADMIN);
        });
        builder.addCase(deleteUserFromGuildAction.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.DELETE_USER_FROM_GUILD);
            if (action.payload.status === 200) {
                state.isDataSent.push(GuildActionsName.DELETE_USER_FROM_GUILD);
                state.members = action.payload.data;
                toast.success('User deleted from Guild!');
            }
        });
        builder.addCase(deleteUserFromGuildAction.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.DELETE_USER_FROM_GUILD);
        });
        builder.addCase(deleteUserFromGuildAction.pending, (state) => {
            state.pending.push(GuildActionsName.DELETE_USER_FROM_GUILD);
        });
        builder.addCase(getAllGuilds.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.GET_ALL_GUILDS);
            if (action.payload.status === 200) {
                state.allGuilds = action.payload.data.data;
            }
            else {
                state.allGuilds = null;
            }
        });
        builder.addCase(getAllGuilds.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.GET_ALL_GUILDS);
        });
        builder.addCase(getAllGuilds.pending, (state) => {
            state.needUpdateGuild = false;
            state.allGuilds = null;
            state.pending.push(GuildActionsName.GET_ALL_GUILDS);
        });
        builder.addCase(createGuild.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.CREATE_GUILD);
            if (action.payload.status === 200) {
                state.error = null;
                state.isDataSent.push(GuildActionsName.CREATE_GUILD);
                state.allGuilds = action.payload.data.data;
                state.guildInfo = action.payload.myGuild.data;
                state.myGuildId = action.payload.myGuild.data.id;
                toast.success('Guild created!');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.CREATE_GUILD);
                state.error = action.payload.data.details;
            }
        });
        builder.addCase(createGuild.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.CREATE_GUILD);
            state.error = '';
            state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.CREATE_GUILD);
        });
        builder.addCase(createGuild.pending, (state) => {
            state.pending.push(GuildActionsName.CREATE_GUILD);
        });
        builder.addCase(editGuild.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.CREATE_GUILD);
            if (action.payload.status === 200) {
                state.error = null;
                state.isDataSent.push(GuildActionsName.CREATE_GUILD);
                state.guildInfo = action.payload.data;
                toast.success('Guild edited!');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.CREATE_GUILD);
                state.error = action.payload.data.details;
            }
        });
        builder.addCase(editGuild.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.EDIT_GUILD);
            state.error = '';
            state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.CREATE_GUILD);
        });
        builder.addCase(editGuild.pending, (state) => {
            state.pending.push(GuildActionsName.CREATE_GUILD);
        });
        builder.addCase(requestGuild.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.REQUEST);
            if (action.payload.status === 200) {
                state.isDataSent.push(GuildActionsName.REQUEST);
                state.guildInfo = action.payload.data;
                state.allGuilds = action.payload.members.data.data;
                toast.success('Request sent!');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.REQUEST);
            }
        });
        builder.addCase(requestGuild.pending, (state) => {
            state.pending.push(GuildActionsName.REQUEST);
            state.error = null;
        });
        builder.addCase(requestGuild.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.REQUEST);
            state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.REQUEST);
        });
        builder.addCase(joinGuild.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.JOIN_GUILD);
            if (action.payload.status === 200) {
                state.isDataSent.push(GuildActionsName.JOIN_GUILD);
                state.guildInfo = action.payload.data;
                state.members = action.payload.members.data;
                toast.success('User joined!');
            }
            else {
                state.error = action.payload.data.details;
                state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.JOIN_GUILD);
            }
        });
        builder.addCase(joinGuild.pending, (state) => {
            state.pending.push(GuildActionsName.JOIN_GUILD);
            state.error = null;
        });
        builder.addCase(joinGuild.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.JOIN_GUILD);
            state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.JOIN_GUILD);
        });
        builder.addCase(leaveGuild.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.LEAVE_GUILD);
            if (action.payload.status === 200) {
                state.isDataSent.push(GuildActionsName.LEAVE_GUILD);
                state.guildInfo = action.payload.myGuild.data;
                state.allGuilds = action.payload.data.data;
                state.myGuildId = undefined;
                toast.success('Guild leaved!');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.LEAVE_GUILD);
            }
        });
        builder.addCase(leaveGuild.pending, (state) => {
            state.pending.push(GuildActionsName.LEAVE_GUILD);
            state.error = null;
        });
        builder.addCase(leaveGuild.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.LEAVE_GUILD);
            state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.LEAVE_GUILD);
        });
        builder.addCase(deleteGuild.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.DELETE_GUILD);
            if (action.payload.status === 200) {
                state.isDataSent.push(GuildActionsName.DELETE_GUILD);
                state.allGuilds = action.payload.data.data;
                state.myGuildId = undefined;
                toast.success('Guild Deleted!');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.DELETE_GUILD);
            }
        });
        builder.addCase(deleteGuild.pending, (state) => {
            state.pending.push(GuildActionsName.DELETE_GUILD);
            state.error = null;
        });
        builder.addCase(deleteGuild.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.DELETE_GUILD);
            state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.DELETE_GUILD);
        });
        builder.addCase(getOneGuild.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.GET_ONE_GUILD);
            if (action.payload.status === 200) {
                state.guildInfo = action.payload.data;
            }
            else {
                state.guildInfo = null;
            }
        });
        builder.addCase(getOneGuild.pending, (state) => {
            state.pending.push(GuildActionsName.GET_ONE_GUILD);
            state.error = null;
            state.needUpdateGuild = false;
        });
        builder.addCase(getOneGuild.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.GET_ONE_GUILD);
            state.needUpdateGuild = false;
        });
        builder.addCase(deleteRequestGuild.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.CANCEL_REQUEST);
            if (action.payload.status === 200) {
                state.allGuilds = action.payload.data.data;
                state.isDataSent.push(GuildActionsName.CANCEL_REQUEST);
                toast.success('Request canceled!');
            }
            else {
                state.guildInfo = null;
                state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.CANCEL_REQUEST);
            }
        });
        builder.addCase(deleteRequestGuild.pending, (state) => {
            state.pending.push(GuildActionsName.CANCEL_REQUEST);
            state.error = null;
        });
        builder.addCase(deleteRequestGuild.rejected, (state) => {
            state.pending = filterOutAction(state.pending, GuildActionsName.CANCEL_REQUEST);
            state.isDataSent = filterOutAction(state.isDataSent, GuildActionsName.CANCEL_REQUEST);
        });
        builder.addCase(checkname.fulfilled, (state, action) => {
            var _a, _b, _c, _d;
            if (((_a = action.payload) === null || _a === void 0 ? void 0 : _a.status) === 200) {
                state.errorOnName = null;
            }
            if (((_b = action.payload) === null || _b === void 0 ? void 0 : _b.status) !== 200 && 'details' in ((_c = action.payload) === null || _c === void 0 ? void 0 : _c.data)) {
                if (action.meta.arg.name === '') {
                    state.errorOnName = null;
                }
                else {
                    state.errorOnName =
                        ((_d = action.payload) === null || _d === void 0 ? void 0 : _d.data.details.replace('name', action.meta.arg.name)) || null;
                }
            }
        });
        builder.addCase(checkname.pending, (state) => {
            log.debug('checkname - Pending');
        });
        builder.addCase(checkname.rejected, (state, action) => {
            state.errorOnName = 'Something went wrong';
        });
    }
});
export const { clearData, setNeedUpdateGuild, switchPhotoAction, resetErrors } = slice.actions;
export default slice.reducer;
